export default "__VITE_ASSET__Bb_l3goU__"